module.exports = __webpack_public_path__ + "cheer.08f3c1ec.png";